import { StatRing } from './StatRing';

// Aligner-advancement pace: go / (go + nogo + go_back). Backed by the
// API's `trackingPct` field (statistical term for the same ratio).

function getPaceColor(pct: number): string {
    if (pct >= 90) return '#10b981';
    if (pct >= 70) return '#f59e0b';
    return '#ef4444';
}

function getPaceLabel(pct: number): string {
    if (pct >= 90) return 'On Pace';
    if (pct >= 70) return 'Slow Pace';
    return 'Stalled';
}

interface PaceRingProps {
    pacePct: number | null;
    goCount: number;
    nogoCount: number;
    goBackCount: number;
    /** False when DM issues no aligner instructions for this monitoring. */
    tracksAligners?: boolean;
}

function PaceRing({
    pacePct,
    goCount,
    nogoCount,
    goBackCount,
    tracksAligners = true
}: PaceRingProps) {
    const offPace = nogoCount + goBackCount;
    const total = goCount + offPace;

    // There is no pace to report on a case without aligners, and "No scans yet"
    // would be a plain lie about a patient who scans every week.
    if (!tracksAligners) {
        return (
            <StatRing
                pct={null}
                color="#9ca3af"
                label=""
                sublabel="Not tracked"
                title="This monitoring issues no aligner-change instructions"
                emptyLabel="Pace"
            />
        );
    }

    return (
        <StatRing
            pct={pacePct}
            color={pacePct != null ? getPaceColor(pacePct) : '#9ca3af'}
            label={pacePct != null ? getPaceLabel(pacePct) : ''}
            sublabel={total > 0 ? `${goCount} go · ${offPace} no-go/gb` : 'No scans yet'}
            title={`${goCount} GO, ${nogoCount} NO-GO, ${goBackCount} GO-BACK`}
            emptyLabel="Pace"
        />
    );
}

export { PaceRing };
